export function Plug(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="SVG">
        <g id="Group">
          <path
            id="Vector"
            d="M1 24.9906L3.95687 22.0337"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M5.7569 11.7485L3.95685 13.5486C2.83146 14.674 2.19922 16.2003 2.19922 17.7919C2.19922 19.3834 2.83146 20.9098 3.95685 22.0352C5.08225 23.1606 6.60861 23.7928 8.20016 23.7928C9.7917 23.7928 11.3181 23.1606 12.4435 22.0352L14.2435 20.2351L5.7569 11.7485Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M24.9998 0.990234L22.043 3.94711"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M20.2434 14.2357L22.0435 12.4356C23.1689 11.3103 23.8011 9.78389 23.8011 8.19234C23.8011 6.6008 23.1689 5.07443 22.0435 3.94904C20.9181 2.82365 19.3917 2.19141 17.8002 2.19141C16.2086 2.19141 14.6823 2.82365 13.5569 3.94904L11.7568 5.74908L20.2434 14.2357Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_5"
            d="M10.6003 11.7905L8.2002 14.1906"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_6"
            d="M14.1999 15.3906L11.7998 17.7907"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}
